[
  {
    "label": "UTC (GMT+00:00)",
    "value": "UTC",
    "name": "(GMT+00:00) UTC",
    "utc": "00:00"
  },
  {
    "label": "Pacific/Honolulu (GMT-10:00)",
    "value": "Pacific/Honolulu",
    "name": "(GMT-10:00) Honolulu, East Honolulu, Pearl City, Hilo, Kailua",
    "utc": "-10:00"
  },
  {
    "label": "America/Anchorage (GMT-09:00)",
    "value": "America/Anchorage",
    "name": "(GMT-09:00) Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview",
    "utc": "-09:00"
  },
  {
    "label": "America/Nome (GMT-09:00)",
    "value": "America/Nome",
    "name": "(GMT-09:00) Nome",
    "utc": "-09:00"
  },
  {
    "label": "America/Los_Angeles (GMT-08:00)",
    "value": "America/Los_Angeles",
    "name": "(GMT-08:00) Los Angeles, San Diego, San Jose, San Francisco, Seattle",
    "utc": "-08:00"
  },
  {
    "label": "America/Tijuana (GMT-08:00)",
    "value": "America/Tijuana",
    "name": "(GMT-08:00) Tijuana, Mexicali, Ensenada, Rosarito, Tecate",
    "utc": "-08:00"
  },
  {
    "label": "America/Denver (GMT-07:00)",
    "value": "America/Denver",
    "name": "(GMT-07:00) Denver, El Paso, Albuquerque, Colorado Springs, Aurora",
    "utc": "-07:00"
  },
  {
    "label": "America/Edmonton (GMT-07:00)",
    "value": "America/Edmonton",
    "name": "(GMT-07:00) Calgary, Edmonton, Fort McMurray, Red Deer, Lethbridge",
    "utc": "-07:00"
  },
  {
    "label": "America/Phoenix (GMT-07:00)",
    "value": "America/Phoenix",
    "name": "(GMT-07:00) Phoenix, Tucson, Mesa, Chandler, Gilbert",
    "utc": "-07:00"
  },
  {
    "label": "America/Chicago (GMT-06:00)",
    "value": "America/Chicago",
    "name": "(GMT-06:00) Chicago, Houston, San Antonio, Dallas, Austin",
    "utc": "-06:00"
  },
  {
    "label": "America/Winnipeg (GMT-06:00)",
    "value": "America/Winnipeg",
    "name": "(GMT-06:00) Winnipeg, Brandon, Kenora, Portage la Prairie, Thompson",
    "utc": "-06:00"
  },
  {
    "label": "America/Cancun (GMT-05:00)",
    "value": "America/Cancun",
    "name": "(GMT-05:00) Cancún, Chetumal, Playa del Carmen, Cozumel, Felipe Carrillo Puerto",
    "utc": "-05:00"
  },
  {
    "label": "America/Cayman (GMT-05:00)",
    "value": "America/Cayman",
    "name": "(GMT-05:00) George Town, West Bay, Bodden Town, East End, North Side",
    "utc": "-05:00"
  },
  {
    "label": "America/Detroit (GMT-05:00)",
    "value": "America/Detroit",
    "name": "(GMT-05:00) Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor",
    "utc": "-05:00"
  },
  {
    "label": "America/Indiana/Indianapolis (GMT-05:00)",
    "value": "America/Indiana/Indianapolis",
    "name": "(GMT-05:00) Indianapolis, Fort Wayne, South Bend, Carmel, Bloomington",
    "utc": "-05:00"
  },
  {
    "label": "America/Nassau (GMT-05:00)",
    "value": "America/Nassau",
    "name": "(GMT-05:00) Nassau, Lucaya, Freeport, West End, Cooper’s Town",
    "utc": "-05:00"
  },
  {
    "label": "America/New_York (GMT-05:00)",
    "value": "America/New_York",
    "name": "(GMT-05:00) New York City, Brooklyn, Queens, Philadelphia, Manhattan",
    "utc": "-05:00"
  },
  {
    "label": "America/Thunder_Bay (GMT-05:00)",
    "value": "America/Thunder_Bay",
    "name": "(GMT-05:00) Thunder Bay",
    "utc": "-05:00"
  },
  {
    "label": "America/Toronto (GMT-05:00)",
    "value": "America/Toronto",
    "name": "(GMT-05:00) Toronto, Montréal, Ottawa, Mississauga, Québec",
    "utc": "-05:00"
  }
]
